/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("TableHeader4STBehavior", ["StyleBehaviorBase"], function (context, cls) {
  /**
   * @class TableHeader4STBehavior
   * @memberOf classes
   * @extends classes.BehaviorBase
   */
  cls.TableHeader4STBehavior = context.oo.Singleton(cls.StyleBehaviorBase, function ($super) {
    return /** @lends classes.TableHeader4STBehavior.prototype */ {
      __name: "TableHeader4STBehavior",

      usedStyleAttributes: ["headerHidden", "headerAlignment", "headerPosition"],
      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        let widget = controller.getWidget();
        let tableNode = controller.getAnchorNode();
        if (!widget || !tableNode) {
          return;
        }

        this._handleHeaderHidden(tableNode, widget);
        this._handleHeaderAlignment(tableNode, widget);
        this._handleHeaderPosition(tableNode, widget);
      },

      /**
       * Apply the headerHidden attribute to the widget given in parameter
       * @param {classes.TableNode} tableNode The table Node to get the data from
       * @param {classes.WidgetBase} widget The widget on which to apply the header alignement
       */
      _handleHeaderHidden(tableNode, widget) {
        const isListView = tableNode.isListView();
        const headerHidden = isListView ? "yes" : tableNode.getStyleAttribute("headerHidden");

        if (widget.setHeaderHidden && headerHidden) {
          widget.setHeaderHidden(this.isSAYesLike(headerHidden));
        }
      },

      /**
       * Apply the headerAlignement attribute to the widget given in parameter
       * @param {classes.TableNode} tableNode The table Node to get the data from
       * @param {classes.WidgetBase} widget The widget on which to apply the header alignement
       */
      _handleHeaderAlignment(tableNode, widget) {
        let headerAlignment = tableNode.getStyleAttribute("headerAlignment");

        if (!(headerAlignment && widget.setHeaderAlignment)) {
          return;
        }

        widget.setHeaderAlignment(headerAlignment);
      },

      /**
       * Apply the headerPosition attribute to the widget given in parameter
       * @param {classes.TableNode} tableNode The table Node to get the data from
       * @param {classes.WidgetBase} widget The widget on which to apply the header alignement
       */
      _handleHeaderPosition(tableNode, widget) {
        let headerPosition = tableNode.getStyleAttribute("headerPosition");

        if (!headerPosition) {
          headerPosition = gbc.constants.headerPosition.left;
        }
        if (widget.setHeaderPosition) {
          widget.setHeaderPosition(headerPosition);
        }
      }
    };
  });
});
